// extracted by mini-css-extract-plugin
export default {"container":"UserLoader_container__Y6MUa","dot":"UserLoader_dot__8fnqT","fx":"UserLoader_fx__3waeG"};